import React from "react";
import { useUser } from "../../../../context/AuthContext";
import Scope3ApprovalListCore from "../Scope3ApprovalListCore";
import SimpleScope3ApprovalDrawer from "../SimpleScope3ApprovalDrawer";

/** Approval list often includes populated `investmentMasterData`; legacy rows may use `investmentMaster` object or flat fields. */
const mapInvestmentsApprovalRow = (item) => {
  const imd = item?.investmentMasterData;
  const im =
    item?.investmentMaster != null && typeof item.investmentMaster === "object"
      ? item.investmentMaster
      : null;
  const pick = (key) => imd?.[key] ?? im?.[key] ?? item?.[key];

  return {
    ...item,
    investmentName:
      pick("investmentName") ?? pick("investeeProjectName") ?? "",
    investmentType: pick("investmentType") ?? "",
    countryOfOperation: pick("countryOfOperation") ?? "",
    sector: pick("sector") ?? "",
    equityHoldingPercent: pick("equityHoldingPercent"),
  };
};

const InvestmentsView = (props) => (
  <SimpleScope3ApprovalDrawer {...props} title="Investments — change request" />
);

const InvestmentsApproval = () => {
  const { user } = useUser();

  const headings = [
    { title: "Date", key: "createdAt" },
    user?.companyAdmin ? { title: "Facility", key: "facilityName" } : null,
    { title: "Investment Name", key: "investmentName" },
    { title: "Investment Type", key: "investmentType" },
    // { title: "Country", key: "countryOfOperation" },
    { title: "Status", key: "requestStatus" },
    { title: "Created By", key: "createdBy" },
  ].filter(Boolean);

  return (
    <Scope3ApprovalListCore
      pageTitle="Investments"
      apiSegment="investments"
      ViewPage={InvestmentsView}
      headings={headings}
      columnWidth={
        user?.companyAdmin
          ? "11% 14% 14% 14% 14% 14% 9%"
          : "12% 20% 20% 18% 18% 8%"
      }
      mapRow={mapInvestmentsApprovalRow}
    />
  );
};

export default InvestmentsApproval;
